require('../../libs/backbone/backbone.ajaxq.adapter.ts');

var HeaderView = require('../views/header.view.ts');
var HomeView = require('../views/home.view.ts');

var TheRouter = Backbone.Router.extend({
	routes: {
		"": "defaultRoute",
		"Home": "homeRoute"
	},
	initialize: function (options) {
		self = this;
	},
	defaultRoute: function () {
        this.navigate('Home', {trigger: true});
	},
	homeRoute: function () {
	    this.clearView();
		this.createHeaderFooter();
		this.view = new HomeView();
	},
    createHeaderFooter: function() {
        this.header = new HeaderView();
    },
	clearView: function() {
        if(this.view){
            this.view.stopListening();
            this.view.$el.empty();
            if(this.view.clearView)
                this.view.clearView();
            this.view.undelegateEvents();
            delete this.view;
            $("body").scrollTop(0);
        }
    }
});

module.exports = TheRouter;